import { Image } from '@chakra-ui/react'
import React from 'react'

const StageBg = () => {
  return <Image src="/bingo/images/bg-stage.webp" width="100%" pointerEvents="none" userSelect="none" />
}

export default StageBg
